module.exports = "/img/5.cced93c3.png";